import { render, staticRenderFns } from "./FloorplanCanvas.vue?vue&type=template&id=48223b39&scoped=true&"
import script from "./FloorplanCanvas.vue?vue&type=script&lang=js&"
export * from "./FloorplanCanvas.vue?vue&type=script&lang=js&"
import style0 from "./FloorplanCanvas.vue?vue&type=style&index=0&id=48223b39&prod&style=scss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48223b39",
  null
  
)

export default component.exports